import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircle } from '@phosphor-icons/react'
import { useBilling } from '../contexts/BillingContext'

export default function CheckoutSuccessPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { refresh } = useBilling()
  const creditsAdded = searchParams.get('credits')

  useEffect(() => {
    const poll = async () => {
      for (let i = 0; i < 10; i++) {
        await new Promise(r => setTimeout(r, 1000))
        await refresh()
      }
    }
    poll()
    const timer = setTimeout(() => navigate('/'), 5000)
    return () => clearTimeout(timer)
  }, [navigate, refresh])

  const isCreditPack = Boolean(creditsAdded)

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div
        className="w-14 h-14 bg-[rgba(48,209,88,0.08)] border border-[rgba(48,209,88,0.2)] flex items-center justify-center mb-6"
        style={{ borderRadius: 2 }}
      >
        <CheckCircle size={32} weight="fill" className="text-[#30D158]" />
      </div>
      <h1 className="type-h2 text-ds-text text-2xl mb-2">
        {isCreditPack ? `+${creditsAdded} créditos añadidos` : '¡Bienvenido a Pro!'}
      </h1>
      <p className="text-ds-muted text-sm max-w-sm" style={{ fontFamily: 'Barlow, sans-serif' }}>
        {isCreditPack
          ? `Tus ${creditsAdded} créditos ya están disponibles. ¡A generar contenido!`
          : 'Tu suscripción está activa. Ahora tienes 200 créditos/mes, analytics completas y más.'}
      </p>
      <p className="text-ds-faint text-xs mt-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
        Redirigiendo al dashboard...
      </p>
    </div>
  )
}
